import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const baseUrl = document.getElementsByTagName('base')[0].href.replace('/Webviewer/', '');
    //console.log(baseUrl)
    if (req.url.indexOf('localhost:') != -1)
      return next.handle(req.clone({ url: req.url }));
    else {
      const apiReq = req.clone({ url: req.url.replace('http://localhost', baseUrl) });
      //console.log(apiReq)
      return next.handle(apiReq);
    }
  }
}
